import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
/* 
      首先 
      1、不能横向 竖向 连续三个 包含字符   qaz zaq 123 111 321 951 159 [;, =-0 8uh  %%% $$$ ^^^
      2、数字 字母不能连续 不能相同三个 aaa 111 
      3、不能包含在用户名中 任意连续三个字符 username  passwardname 
      4、只支持英文符号 过滤中文符号比如 。 、 ， ‘ “ 【 】 · 、等
      5、用户名限制最低长度，最低5个字符
      6、不能包含中文符号
  */

// 所有键盘组合值
// 三个连续的 纵向的 横向的 相同的 数字 字母 符号
var charAll = [];

// 所有的中文符号
var allChinaChar = ["·", "【", "】", "；", "：", "’", "”", "“", "‘", "，", "。", "、", "？", "《", "》", "！", "￥", "…", "（", "）", "—"];

/**
 * 键盘字符表(小写)
 * 非shift键盘字符表
 */
var charList1 = [["`", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "-", "=", ""], ["", "q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "[", "]", "\\"], ["", "a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "'", "", ""], ["", "z", "x", "c", "v", "b", "n", "m", ",", ".", "/", "", "", ""]];

/**
 * 
 * shift键盘的字符表
 */
var charList2 = [["~", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "_", "+", ""], ["", "q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "{", "}", "|"], ["", "a", "s", "d", "f", "g", "h", "j", "k", "l", ":", '"', "", ""], ["", "z", "x", "c", "v", "b", "n", "m", "<", ">", "?", "", "", ""]];

// 所有符号集合
var SpecialStr = "`[]!@#$%^&*()-=;_+'/,." + '?":{}|<>\\';

// 长度需min-max位，数字、小写字母、大写字母、特殊字符，至少包含三种
// return true  为通过校验
function validateFormat(val) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
  console.log("val", val);
  if (val.length < min || val.length > max) {
    return false; // 长度不符合要求
  }
  var hasLower = /[a-z]/.test(val);
  var hasUpper = /[A-Z]/.test(val);
  var hasDigit = /\d/.test(val);
  var hasSpecial = /[`\[\]!@#$%^&*()\-=\;_+'/,.?":{}|<>\\]/.test(val); // 根据需要调整这个特殊字符集
  // const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(val);
  var typeCount = 0;
  if (hasLower) typeCount++;
  if (hasUpper) typeCount++;
  if (hasDigit) typeCount++;
  if (hasSpecial) typeCount++;
  return typeCount >= 3; // 至少包含三种类型的字符
}

// 是否包含中文符号
var isHasChinaCharFun = function isHasChinaCharFun(str) {
  return allChinaChar.some(function (i) {
    return str.includes(i);
  });
};

/**
 *
 * @returns 返回键盘所有符合条件的集合
 */
function getCharAll() {
  var _charAll;
  charAll = [];
  // 横向所有的值(正序和反序)-
  charList1.concat(charList2).forEach(function (item, index) {
    charAll.push(item.join(""), Object.assign([], item).reverse().join(""));
  });
  // 0: "`1234567890-="
  // 1: "=-0987654321`"
  // 反斜杠纵向所有的值(正序和反序)\
  // 这里得到的数据例如是 1qaz 2wsx 3edc
  var _loop = function _loop(i) {
    var sb1 = [];
    var sb2 = [];
    charList1.forEach(function (item) {
      sb1.push(item[i]);
    });
    charList2.forEach(function (item) {
      sb2.push(item[i]);
    });
    // 去除长度小于3的值
    if (sb1.join("").length >= 3) {
      charAll.push(sb1.join(""), Object.assign([], sb1).reverse().join(""));
      charAll.push(sb2.join(""), Object.assign([], sb2).reverse().join(""));
    }
  };
  for (var i = 0; i < charList1[0].length; i++) {
    _loop(i);
  }
  // return false
  // 正斜杠纵向所有的值(正序和反序)/
  // 这里得到的数据例如是 0okm 9ijn 8uhb 7ygv
  var _loop2 = function _loop2(_i) {
    var sb1 = [];
    var sb2 = [];
    //   比如说 当前i === 8
    // 那也就是说charList1[0]选中的是 8
    // 那也就是说charList1[1]应该选中的是 u  i-下标（1）等于7  正好是u
    // 那也就是说charList1[2]应该选中的是 h  i-下标（2）等于6  正好是h
    // 那也就是说charList1[3]应该选中的是 b  i-下标（3）等于5  正好是b
    charList1.forEach(function (item, index) {
      if (_i - index >= 0) sb1.push(item[_i - index]);
    });
    charList2.forEach(function (item, index) {
      if (_i - index >= 0) sb2.push(item[_i - index]);
    });
    // 去除长度小于3的值
    if (sb1.join("").length >= 3) {
      charAll.push(sb1.join(""), Object.assign([], sb1).reverse().join(""));
      charAll.push(sb2.join(""), Object.assign([], sb2).reverse().join(""));
    }
  };
  for (var _i = 0; _i < charList1[0].length; _i++) {
    _loop2(_i);
  }
  //   aaa 111 %%%
  var chart26 = "abcdefghijklmnopqrstuvwxyz";
  var str = chart26 + "1234567890" + SpecialStr;
  var strList = [];
  // 这里也可以直接使用 charList1和charList2去重然后再循环
  for (var _i2 = 0; _i2 < str.length; _i2++) {
    strList = [].concat(_toConsumableArray(strList), [str[_i2] + str[_i2] + str[_i2]]);
  }
  (_charAll = charAll).push.apply(_charAll, ["abcdefghijklmnopqrstuvwxyz"].concat(_toConsumableArray(strList)));
  // 将得到的所有字符组合 以上都是超过三位的组合
  // 目前的要求是超过三位包含三位都算连续 比如 qaz 1qa aq1 zaq 还需要在处理一下...
  // 如果不需要 跳过这个循环就行
  charAll.forEach(function (item) {
    if (item.length > 3) {
      var _charAll2;
      (_charAll2 = charAll).push.apply(_charAll2, _toConsumableArray(overlappingSplitByThree(item)));
    }
  });

  // 去重
  charAll = _toConsumableArray(new Set(charAll));
  //  增加小键盘 123 456 789
  //  charAll.push("159", "951", "753", "357");
  charAll.push("147", "741", "258", "852", "369", "963");
  return charAll;
}

//  将字符串三个三个一组
// 例如 "asdfghbvcx"  输出: "asd,sdf,dfg,fgh,ghb,hbv,bvc,vcx"
/**
 *
 * @param {*} str 要分割的字符
 * @param {*} flag 默认true 加上反转
 * @returns
 */
function overlappingSplitByThree(str) {
  var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var result = [];
  for (var i = 0; i <= str.length - 3; i++) {
    result.push(str.slice(i, i + 3));
  }
  // 如果需要返回逗号分隔的字符串，可以使用 join 方法
  // return result.join(',');
  // 但这里按照要求返回数组
  return flag ? [].concat(result, _toConsumableArray(overlappingSplitByThree(str.split("").reverse().join(""), false))) : [].concat(result);
}

/**
 *
 * @param {*} str
 * @returns 含有中文返回 false
 */
function checkNoChinese(str) {
  var regex = /^[^\u4e00-\u9fa5]+$/;
  return regex.test(str);
}

/**
 *
 * @param {*} password 密码
 * @param {*} username 用户名
 * @returns Object
 */
export var checkPasswordFun = function checkPasswordFun(password) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
  // 判断账号
  // if (!username || username.trim() === "") {
  //   return {
  //     flag: false,
  //     message: "请输入用户名",
  //   };
  // }
  // 判断账号最小长度
  // if (username.length < 5) {
  //   return {
  //     flag: false,
  //     message: "用户名最小长度为5",
  //   };
  // }
  // 判断密码是否存在
  if (!password || password.trim() === "") {
    return {
      flag: false,
      message: "请输入密码"
    };
  }
  if (!checkNoChinese(password)) {
    return {
      flag: false,
      message: "密码中不能包含中文"
    };
  }
  // 判断密码位数是否符合要求
  if (!validateFormat(password, min, max)) {
    return {
      flag: false,
      message: "\u5BC6\u7801\u957F\u5EA6\u4E3A".concat(min, "-").concat(max, "\u4F4D\uFF0C\u6570\u5B57\u3001\u5C0F\u5199\u5B57\u6BCD\u3001\u5927\u5199\u5B57\u6BCD\u3001\u7279\u6B8A\u5B57\u7B26\uFF0C\u81F3\u5C11\u5305\u542B\u4E09\u79CD")
    };
  }
  password = password.toLowerCase();
  // username = username.toLowerCase();
  // 判断密码是否包含中文特殊字符
  if (isHasChinaCharFun(password)) {
    return {
      flag: false,
      message: "密码不能包含中文特殊字符"
    };
  }
  // 判断密码中是否包含用户名连续三位
  var passwordList = _toConsumableArray(overlappingSplitByThree(password, false));
  // const usernameList = [...overlappingSplitByThree(username, false)];
  //  两个长度去重之后 长度不相等 说明有重合的 直接毙掉
  if (_toConsumableArray(new Set(_toConsumableArray(passwordList))).length !== passwordList.length) {
    return {
      flag: false,
      message: "密码不能包含包含连续或键盘横竖三位的数字、字母、字符"
    };
  }
  // if (
  //   passwordList.length + usernameList.length !==
  //   [...new Set([...passwordList, ...usernameList])].length
  // ) {
  //   return {
  //     flag: false,
  //     message: "密码不能包含账号字符连续三位、",
  //   };
  // }

  // 判断密码中是否包含连续三位数字 字母 字符
  var charAll = getCharAll();
  if (charAll.some(function (i) {
    return password.includes(i);
  })) {
    return {
      flag: false,
      message: "密码不能包含包含连续或键盘横竖三位的数字、字母、字符"
    };
  }
  return {
    flag: true
  };
};
export default {
  checkPasswordFun: checkPasswordFun
};